import { ColorName } from '@shinetools/sunshine';

import { CreditCardStatusCode } from '__generated__/GQL';
import assertNever from 'common/bento/lib/assertNever';

import { isCreditCardFragment } from '../../../../../../hooks/usePaymentCardsList';
import { PaymentCardListTable_ItemFragment } from '../../../../../../hooks/usePaymentCardsList/paymentCardsList.gql';
import locales from './locales';

export const getPaymentCardStatusBadgeColor = (
  creditCard: PaymentCardListTable_ItemFragment,
): ColorName => {
  const { status } = creditCard;

  if (isCreditCardFragment(creditCard) && creditCard.pinTryExceeds) {
    return 'red';
  }

  switch (status) {
    case CreditCardStatusCode.Active:
      return 'green';
    case CreditCardStatusCode.Lost:
    case CreditCardStatusCode.Deactivated:
    case CreditCardStatusCode.Stolen:
    case CreditCardStatusCode.Locked:
      return 'red';
    case CreditCardStatusCode.Created:
      return 'blue';
    case CreditCardStatusCode.Inactive:
      return 'yellow';
    default:
      return assertNever(status);
  }
};

export const getPaymentCardStatusBadgeLabel = (
  creditCard: PaymentCardListTable_ItemFragment,
): string => {
  const { status } = creditCard;
  if (isCreditCardFragment(creditCard) && creditCard.pinTryExceeds) {
    return locales.LOCKED;
  }

  return locales[status];
};
